import { getContractAddress } from "src/Addresses";
import { PLP_TYPES } from "src/constants/tokens";

export const getOrderBookAddress = (chainID, plpName) => {
  let orderBookAddress1 = getContractAddress(chainID, "OrderBook_PLP_β");
  if (plpName == PLP_TYPES.PLP_2) {
    orderBookAddress1 = getContractAddress(chainID, "OrderBook_PLP_α");
  }
  return orderBookAddress1
}

export const getPositionManagerAddress = (chainID, plpName) => {
  let positionManagerAddress1 = getContractAddress(chainId, "PositionManager_PLP_β");
  if (plpName == PLP_TYPES.PLP_2) {
    positionManagerAddress1 = getContractAddress(chainID, "PositionManager_PLP_α");
  }
  return positionManagerAddress1
}